import { useState } from "react";
import Header from "./Header";
import Hero from "./Hero";
import SolutionsSection from "./SolutionsSection";
import Process from "./Process";
import AdvantagesSection from "./AdvantagesSection";
import IndustriesSection from "./industries";
import Slogan from "./Slogan";
import Footer from "./Footer";
import ContactModal from "./ContactModal";

export default function Landing() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="landing-root">
      <Header onRequestDemo={() => setModalOpen(true)} />
      <Hero    onRequestDemo={() => setModalOpen(true)} />
      <SolutionsSection />
      <Process />
      <AdvantagesSection onRequestDemo={() => setModalOpen(true)} />
      <IndustriesSection />
      <Slogan onRequestDemo={() => setModalOpen(true)} />
      <Footer onRequestDemo={() => setModalOpen(true)} />
      <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}
